import { render, staticRenderFns } from "./platformSettlementFundDetail.vue?vue&type=template&id=b4bf3a80&scoped=true"
import script from "./platformSettlementFundDetail.vue?vue&type=script&lang=js"
export * from "./platformSettlementFundDetail.vue?vue&type=script&lang=js"
import style0 from "./platformSettlementFundDetail.vue?vue&type=style&index=0&id=b4bf3a80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bf3a80",
  null
  
)

export default component.exports